import moment from 'moment';
import store from '@/store/store';
class Report {
    //Rest properties
    id;
    //type: string;
    tariffId;
    from;
    to;
    comment;
    userId;
    //public status: string;
    //Data enrichment
    date;
    hours;
    customerName = '';
    tariffName = '';
    inProgress = false;
    billable = false;
    type = '';
    absence = '';
    rate = 0;
    lastSaved = '';
    //dateHandler: DateHandler; //handles all date functions
    constructor(reportJson) {
        this.id = reportJson.id || '';
        //this.type = reportJson.type || '';
        this.tariffId = reportJson.tariffId || '';
        this.from = window.dateHandler.convertToUTCTime(reportJson.from) || window.dateHandler.convertToUTCTime(new Date());
        this.to = window.dateHandler.convertToUTCTime(reportJson.to) || window.dateHandler.convertToUTCTime(new Date());
        this.comment = reportJson.comment || '';
        this.userId = reportJson.userId || '';
        //this.status  = reportJson.status || '';
        this.date = window.dateHandler.formatDateNoTime(this.from) || window.dateHandler.formatDateNoTime(new Date());
        this.hours = this.calculateHours(this.from, this.to) || 0;
        this.getTariffData();
    }
    // determines the height of each induvidual report
    calulateReportHeight(dayHours) {
        const percentage = (this.hours / dayHours) * 100 + "%";
        return percentage;
    }
    calculateHours(from, to) {
        return moment.duration(moment(to).diff(moment(from))).asHours();
    }
    //populates the report data based on its given tariff
    getTariffData() {
        const tariffs = store.getters.getGlobalTariffs;
        const tariff = tariffs.getTariffFromId(this.tariffId);
        this.tariffName = tariff.name;
        this.customerName = tariff.customerName;
        this.billable = tariff.billable;
        this.type = tariff.type;
        this.absence = tariff.absence;
    }
}
export default Report;
